import React, { useState } from "react";
import styled from "styled-components";
import Plot from "react-plotly.js";
import { useRef, useEffect } from "react";

const Wrapper = styled.section`
  background-color: #fff;
  height: 90%;
  width: 50%;
  overflow-x: scroll;
`;

function Chart({ well_data }) {
  const plot_data = useRef([]);
  const wellData = useRef({});
  const colorID = useRef(0)
  const arr = useRef([
    "#f00",
    "#007bff",
    "#fff314",
    "#25e410",
    "#b5650f",
    "#e31bd9",
    "#12dbf1",
    "#09897c",
    "#e04853",
    "#e69a1f",
    "#294d05",
    "#c53108",
    "#4455d3",
  ]).current;
  function run() {
    let AOF = 0;
    plot_data.current = [];
    colorID.current = 0;
    well_data.forEach((data, i) => {
      let bubble_pres =
        18.2 *
        (Math.pow(data.solution_gor / data.Yg, 0.83) *
          Math.pow(10, 0.00091 * data.res_temp - 0.0125 * data.Yo) -
          1.4);
      const wellDataRef = wellData.current;
      wellDataRef.bubble_pres = bubble_pres;
      const formation_Bo =
        0.9759 +
        0.00012 *
          Math.pow(
            data.solution_gor * Math.pow(data.Yg / data.Yo, 0.5) + 1.251,
            1.2
          );
      wellDataRef.formation_Bo = formation_Bo;
      const dead_Uo =
        Math.pow(
          10,
          Math.pow(10, 3.0324 - 0.02023 * data.Yo) *
            Math.pow(data.res_temp, -1.163)
        ) - 1;
      wellDataRef.dead_Uo = dead_Uo;
      const bubble_Uo =
        10.715 *
        Math.pow(data.solution_gor + 100, -0.515) *
        Math.pow(dead_Uo, 5.44 * Math.pow(data.solution_gor + 150, -0.338));
      wellDataRef.bubble_Uo = bubble_Uo;
      //  let viscosity = data.res_pressure<bubble_pres? bubble_Uo: bubble_Uo*Math.pow(data.res_pressure/bubble_pres, 2.6*Math.pow(data.res_pressure, 1.187)*Math.pow(10, -3.9*Math.pow(10, -5)*data.res_pressure-5));
      const viscosity = dead_Uo;
      wellDataRef.viscosity = viscosity;

      const value =
        0.5 *
        Math.log(
          (10.06 * data.drain_area * 43560) /
            ((data.shape_factor * data.wellbore_radius * data.wellbore_radius) /
              144)
        );
      const J =
        Number(0.00708 * data.perm_k * data.res_thickness) /
        Number(formation_Bo * viscosity * (value - 0.75 + data.skin));

      const q = [];
      const Pwf = [];
      let temp_res_pressure = data.res_pressure;
      let temp_q = 0;
      // STRAIGHT LINE IPR
      if (data.res_pressure > bubble_pres) {
        AOF = J * data.res_pressure;
        while (true) {
          Pwf.push(temp_res_pressure);
          q.push(temp_q);
          temp_q += 800;
          temp_res_pressure = data.res_pressure - (1 / J) * temp_q;
          if (temp_res_pressure <= 0) {
            Pwf.push(0);
            q.push(AOF);
            break;
          }
        }
      } else {
        // VOGEL IPR MODEL
        AOF = 0.8 * J * data.res_pressure;
        while (true) {
          Pwf.push(temp_res_pressure);
          q.push(temp_q);
          temp_res_pressure -= 250;
          temp_q =
            J *
            data.res_pressure *
            0.8 *
            (1 -
              0.2 * (temp_res_pressure / data.res_pressure) -
              0.8 * Math.pow(temp_res_pressure / data.res_pressure, 2));
          if (temp_res_pressure <= 0) {
            Pwf.push(0);
            q.push(AOF);
            break;
          }
        }
      }
      colorID.current+=1;
      if(colorID.current>=arr.length) colorID.current=1;
      const rand = colorID.current;
      console.log(rand);
      const plotData = {
        x: q,
        y: Pwf,
        type: "scatter",
        mode: "lines+markers",
        marker: { color: arr[rand] },
        name: `Pr: ${data.res_pressure} psia, S: ${data.skin}, J: ${J.toFixed(
          3
        )} bbl/day/psi, AOF: ${AOF.toFixed(2)} STB/day`,
        showlegend: true
      };
      plot_data.current.push(plotData);
      console.log(plot_data);
    });
  }
  run();
  useEffect(() => {}, [well_data]);
  return (
    <Wrapper>
      <Plot
        style={{ borderRadius: "12px" }}
        data={plot_data.current}
        layout={{
          autosize: true,
          width: "1200",
          height: "700",
          title: { text: "IPR Plot (Group 6 PET 516 Presentation)" },
          yaxis: {
            title: {
              text: "Flowing Bottom-Hole Pressure, Pr (psia)",
              font: {
                family: "Courier New, monospace",
                size: 10,
                color: "red",
              },
            },
          },
          xaxis: {
            title: {
              text: "Production Rate, Qo (STB/day)",
              font: {
                family: "Courier New, monospace",
                size: 10,
                color: "red",
              },
            },
          },
        }}
        config={{ responsive: true }}
      />
    </Wrapper>
  );
}

export default Chart;
